import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { BaseSearchController } from "../_baseSearchController";
import { JobService } from "../../services/job-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { EventService } from "../../services/event-service";
import { SearchService } from "../../services/search-service";
import { WorkflowService } from "../../services/workflow-service";

export class JobSearchController extends BaseSearchController<Models.IEntitySearchDoc>{
	static $inject = ["$scope", "$q", "$location", "$filter", "jobService", "localCacheService", "notifyService", "notifyService", "entityService", "$window", "eventService", "workflowService"];

	filterByEntityID: string;
	entityRecord: Models.IEntity;
	visibility: number;
	activeFlag: boolean;
	charTypeName: string;
	listUrl: string;

	selectedJobIDs: number[];
	selectedJobTitles: string[];

	selectedTemplate: string;
	selectedStatus: string;

	constructor(
		$scope: ng.IScope,
		$q: ng.IQService,
		$location: ng.ILocationService,
		private $filter: ng.IFilterService,
		private jobService: JobService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		entityService: EntityService,
		private $window: ng.IWindowService,
		private eventService: EventService,
		private searchService: SearchService,
		private workflowService: WorkflowService) {

		super($scope, $q, $location, $filter, localStorage, notifyService, entityService, searchService);

		this.charTypeId = Consts.CharTypeIDs.job;

		this.visibility = 1;
		this.charTypeName = "";
		this.listUrl = "~/";
		this.selectedJobIDs = [];
		this.selectedJobTitles = [];
		$scope.$watch(() => this.selectedItems, (newValue: { [key: string]: boolean }) => {
			this.selectedJobIDs = _(newValue)
				.pairs()
				.filter((el) => el[1] === true)
				.map<number>((el: [string, boolean]) => _.parseInt(el[0].split("|")[0]))
				.valueOf();

			this.selectedJobTitles = _(newValue)
				.pairs()
				.filter((el) => el[1] === true)
				.map<string>((el: [string, boolean]) => el[0].split("|")[1])
				.valueOf();
		}, true);

		$scope.$watchCollection(() => [this.selectedStatus, this.selectedTemplate], (newValue) => {
			if (newValue[0] && newValue[1]) {
				var templateID = parseInt(this.selectedTemplate.split('|')[1]);
				var statusID = parseInt(this.selectedStatus.split('|')[1]);

				this.workflowService.getAvailableWorkflowActions(Consts.CharTypeIDs.job, templateID, statusID)
					.then((res) => {
						this.workflowActions = _.map(res, (action) => {
							return {
								key: action.actionName,
								value: action.actionID
							}
						});
					});
			} else {
				this.workflowActions = [];
			}
		});
	}

	Init(filterByEntityID: string, activeFlag: string, charTypeName: string, listUrl: string) {
		if (!_.isEmpty(filterByEntityID)) {
			this.filterByEntityID = filterByEntityID;
			this.relatedSearch = true;
			var filterCharTypeID = Utils.IdBuilder.splitEntityID(filterByEntityID).charTypeID;
			this.entityService.getEntityRecord(filterByEntityID)
				.then((result) => {
					this.entityRecord = result;
				});
		}
		if (!_.isEmpty(activeFlag)) {
			this.activeFlag = activeFlag == "true";
		}
		if (!_.isEmpty(charTypeName)) {
			this.charTypeName = charTypeName;
		}
		if (!_.isEmpty(listUrl)) {
			this.listUrl = listUrl;
		}
		this.initialized = true;
	}

	Search() {
		var query: Models.IAdvancedSearchModel = {
			charTypeID: Consts.CharTypeIDs.job,
			searchGroups: [],
			keywords: this.keywords || "",
			template: this.selectedTemplate,
			status: this.selectedStatus,
			page: this.page || 1,
			rowCount: 20,
			sortField: this.sortField,
			sortDir: this.sortDir,
			relatedToMe: this.relatedToMe,
			filterByEntityID: this.filterByEntityID || "",
			activeIndicator: this.activeFlag
		}

		this.notifyService.startProgress();
		this.searchService.advancedSearch(query)
			.then((result) => {
				this.itemRows = result.documents;
				this.qTime = result.qTime;
				this.numFound = result.numFound;
				this.pageCount = Math.ceil(result.numFound / 20);

				this.templateFacets = result.getTemplateFacets();
				this.statusFacets = result.getStatusFacets();
			})
			.finally(() => {
				this.initialized = true;
				this.notifyService.endProgress();
			});
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.entityRecord.id)
				.then(() => {
					this.$window.location.assign(this.listUrl);
				},
				() => {
					this.notifyService.notifyError("Error Deleting " + this.charTypeName + "");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation();
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	// is a	non-empty workflow action selected
	HasWorkflowAction() {
		return !_.isNaN(_.parseInt(this.selectedAction));
	}

	// execute a workflow task on the selected contacts
	RunWorkflow() {
		// if there	is a selected action and contacts	selected
		if (this.HasWorkflowAction() && this.selectedJobIDs.length > 0) {
			// join	the	titles for a confirmation window
			var titles = this.selectedJobTitles.join(",\n");
			if (this.$window.confirm("Are you sure you want to execute workflow on: \n" + titles)) {
				// execute workflow
				this.notifyService.startProgress(); // start	progress bar
				var promises = [];

				this.workflowService.createBatchID()
					.then((batchIDResult) => {
						var charTypeID = Consts.CharTypeIDs.job;
						var actionID = _.parseInt(this.selectedAction);
						var templateID = _.parseInt(this.selectedTemplate.split('|')[1]);
						var statusID = _.parseInt(this.selectedStatus.split('|')[1]);

						this.workflowService.getAvailableWorkflowActions(charTypeID, templateID, statusID)
							.then((results) => {
								var actions = results;
								var processID = _.find(actions, (a) => { return a.actionID == actionID; }).processID;

								_.each(this.selectedJobIDs, (c) => {
									promises.push(this.ExecuteWorkflow(batchIDResult.batchID, charTypeID, c, actionID, processID, statusID));
								});

								this.$q.all(promises)
									.then(() => {
										//Passing in 0 as the recID as this is not needed to process the notifications from a queue.  It really is just for logging.
										//To call this method from a loop statement would process a queue multiple times, which results in duplicate emails.
										//We only need to call this once when the queue has been fully populated
										this.workflowService.sendNotificationsFromQueue(charTypeID, 0, batchIDResult.batchID)
											.then((sentResult) => {
											}, () => {
												this.notifyService.notifyError("There was an error executing your workflow action.");
											});
									})
									.then(() => {
										this.notifyService.notifySuccess("Workflow action successful!");
									}, () => {
										this.notifyService.notifySuccess("Workflow action could not be completed");
									})
									.finally(() => {
										this.selectedItems = {};
										this.search = true;
										this.notifyService.endProgress();
									});
							});
					});
			}
		} else {
			this.notifyService.notifyError("Please select a workflow action and select contacts from the search results");
		}
	}

	AllCheckChanged() {
		_.forEach(this.itemRows, (itemRow) => {
			this.selectedItems[itemRow.recordID + "|" + itemRow.title] = this.allChecked;
		});
	}

	ExecuteWorkflow(batchID: string, charTypeID: number, recordID: number, actionID: number, processID: number, statusID: number): ng.IPromise<any> {
		return this.workflowService.addNotificationsToQueue(charTypeID, recordID, actionID, batchID, processID)
			.then((result) => {
				return this.workflowService.runPreProcess(charTypeID, processID, actionID, recordID, statusID)
					.then(() => {
						return this.workflowService.workflowUpdateEntityStatus(charTypeID, processID, actionID, recordID, statusID)
							.then((result) => {
								if (result.statusID > 0) {
									var newStatusID = result.statusID;
									return this.workflowService.runPostProcess(charTypeID, processID, actionID, recordID, statusID)
										.then(() => {
										}, () => {
											this.notifyService.notifyError("There was an error executing your workflow action.");
										});
								}
								else {
									this.notifyService.notifyError("There was an error executing your workflow action.");
								}
							}, () => {
								this.notifyService.notifyError("There was an error executing your workflow action.");
							});
					}, () => {
						this.notifyService.notifyError("There was an error executing your workflow action.");
					});

			}, () => {
				this.notifyService.notifyError("There was an error executing your workflow action.");
			});
	}
}